import React from 'react';

import { HeaderContentQuery$data } from '__generated__/HeaderContentQuery.graphql';
import { Footer, WebViewFocusHeader } from 'shared/components';
import DynamicFooter from 'shared/components/Footer/DynamicFooter';
import DynamicHeader from 'shared/components/Header/DynamicHeader';
import DynamicWebViewFocusHeader from 'shared/components/webView/DynamicWebViewFocusHeader';
import { useIsWebView } from 'shared/providers/isWebView';
import { Header } from '../../components';

interface GlobalNavsLayoutProps {
  children: React.ReactNode;
  onLogout?: () => void;
  showHeader?: boolean;
  showFooter?: boolean;
  ssr?: boolean;
  headerContent?: HeaderContentQuery$data;
}

function WebViewHeader({ ssr }: { ssr: boolean }) {
  return ssr ? <DynamicWebViewFocusHeader /> : <WebViewFocusHeader />;
}

export default function GlobalNavsLayout({
  children,
  onLogout,
  showFooter = true,
  showHeader = true,
  ssr = false,
}: GlobalNavsLayoutProps) {
  const isWebView = useIsWebView();

  let headerComponent;
  let footerComponent = null;

  if (isWebView) {
    headerComponent = <WebViewHeader ssr={ssr} />;
  } else {
    headerComponent = ssr ? (
      <Header onLogout={onLogout} showSearch showCart />
    ) : (
      <DynamicHeader onLogout={onLogout} showSearch showCart />
    );

    footerComponent = ssr ? <DynamicFooter /> : <Footer />;
  }

  return (
    <>
      {showHeader ? headerComponent : null}
      {children}
      {showFooter ? footerComponent : null}
    </>
  );
}
